import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4c301f3a"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = ["src"]
const _hoisted_3 = ["id"]
const _hoisted_4 = ["src"]

import { ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  props: {
    answer: null,
    id: null,
    isDraggableElement: { type: Boolean },
    disabled: { type: Boolean },
    icon: null
  },
  emits: ['on-card-click'],
  setup(__props: any, { emit }) {

const props = __props as {
  answer?: string
  id: number
  isDraggableElement: boolean
  disabled?: boolean
  icon?: string
}





const dragging = ref(false)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function onDragStart(ev: any) {
  ev.dataTransfer.setData('text/plain', ev.target.id)

  dragging.value = true
}

function onDragEnd() {
  dragging.value = false
}

return (_ctx: any,_cache: any) => {
  return (props.isDraggableElement)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        id: `${props.id}`,
        class: _normalizeClass(["quizz-illustration-card card-draggable", { isUsed: props.disabled || dragging.value }]),
        onDragstart: onDragStart,
        onDragend: onDragEnd
      }, [
        _createTextVNode(_toDisplayString(props.answer && _ctx.$t(props.answer)) + " ", 1),
        _createElementVNode("img", {
          class: "d-none d-sm-none d-md-block d-lg-block",
          src: props.icon
        }, null, 8, _hoisted_2)
      ], 42, _hoisted_1))
    : (_openBlock(), _createElementBlock("button", {
        key: 1,
        id: `${props.id}`,
        class: _normalizeClass(["quizz-illustration-card btn", { isUsed: props.disabled }]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('on-card-click', props.id)))
      }, [
        _createTextVNode(_toDisplayString(props.answer && _ctx.$t(props.answer)) + " ", 1),
        _createElementVNode("img", {
          class: "d-none d-sm-none d-md-block d-lg-block",
          src: props.icon
        }, null, 8, _hoisted_4)
      ], 10, _hoisted_3))
}
}

})